import { createApp } from "vue";
import StudentImportManager from "./components/StudentImportManager.vue";
import StudentMaskManager from "./components/StudentMaskManager.vue";
import { parseBoolean } from "./utils/parseBoolean";

const APP_ATTRIBUTE = "data-vue-mounted";

function readStudentsPayload(element) {
  const payloadElementId = element.dataset.payloadElementId || `${element.id}-data`;
  const payloadElement = document.getElementById(payloadElementId);

  if (!payloadElement) {
    return [];
  }

  try {
    const parsed = JSON.parse(payloadElement.textContent || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (_error) {
    return [];
  }
}

function resolveElement(root, selector) {
  if (root instanceof Element && root.matches(selector)) {
    return root;
  }

  return root.querySelector(selector);
}

function mountComponent(element, Component, props) {
  if (!element || element.hasAttribute(APP_ATTRIBUTE)) {
    return null;
  }

  const app = createApp(Component, props);
  app.mount(element);
  element.setAttribute(APP_ATTRIBUTE, "1");

  return app;
}

export function initStudentManagerApp(root = document) {
  const mountedApps = [];

  const managerElement = resolveElement(root, "#student-manager");
  if (managerElement) {
    const managerApp = mountComponent(managerElement, StudentMaskManager, {
      sheetId: Number.parseInt(managerElement.dataset.sheetId || "0", 10) || 0,
      schoolId: Number.parseInt(managerElement.dataset.schoolId || "0", 10) || 0,
      canManage: parseBoolean(managerElement.dataset.canManage),
      canImport: parseBoolean(managerElement.dataset.canImport),
      apiUrl: managerElement.dataset.apiUrl || "",
      importPageUrl: managerElement.dataset.importPageUrl || "",
      students: readStudentsPayload(managerElement),
    });

    if (managerApp) {
      mountedApps.push(managerApp);
    }
  }

  const importElement = resolveElement(root, "#student-import-manager");
  if (importElement) {
    const importApp = mountComponent(importElement, StudentImportManager, {
      schoolId: Number.parseInt(importElement.dataset.schoolId || "0", 10) || 0,
      canImport: parseBoolean(importElement.dataset.canImport),
      studentsListUrl: importElement.dataset.studentsUrl || "",

      importMetaUrl: importElement.dataset.importMetaUrl || "",
      importTemplateUrl: importElement.dataset.importTemplateUrl || "",
      importValidateUrl: importElement.dataset.importValidateUrl || "",
      importUrl: importElement.dataset.importUrl || "",
      csrfToken: importElement.dataset.csrfToken || "",
    });

    if (importApp) {
      mountedApps.push(importApp);
    }
  }

  if (mountedApps.length === 0) {
    return null;
  }

  return mountedApps.length === 1 ? mountedApps[0] : mountedApps;
}
